export function replaceWithResolvedRoute (router, location) {
  return new Promise((resolve, reject) => {
    router.replace(location, () => resolve(router.currentRoute.value), reject)
  })
}
